import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.nome;
export default function CampoTitulo() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'nome',
        etapa: EtapaProjeto.tituloDoProjeto,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );
  return (
    <Row>
      <Col>
        <CustomTextField
          label={language.label}
          placeholder={language.placeholder}
          name='preTitulo'
          value={state.projeto.nome ?? ''}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: { nome: evt.target.value },
            });
          }}
          counter={true}
          maxSize={200}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
